import { useGraphQLApi } from "@/components/Common/useGraphQLApi";
import { useStoreData } from "@/components/Common/useStoreData";

export function useGetTopAlertsPerService({ subType }) {
  const { getDurationTime } = useStoreData();
  
  const { data, error, makegraphQLCall, isLoading } = useGraphQLApi({
    params: {},
    queryName: "",
  });

  const fetchTopAlertsPerService = () => {
    const params = {
      condition: {
        entity: {
          scope: "All",
        },
        capability: "C",
        subType,
      },
      duration: getDurationTime.value,
    };
    makegraphQLCall(
      "getTopAlertsPerService",
      params,
      (resp) =>  resp?.data?.data?.getTopAlertsPerService?.alertsApps
    );
  };

  return {
    data: data,
    error,
    fetchTopAlertsPerService,
    isLoading,
  };
}
